import { Grid, List, ListItemText, Typography } from '@mui/material';
import XMLViewer from 'react-xml-viewer';

import { Modal } from '@shared/components/modals/Modal';
import { ListHeader, XmlWrapper } from '@styles/ContactManager/FinancingDetailsModalStyles';

import { ViewXmlModalProps } from '../interfaces';

const getDefaultText = (isApplication = false) => (
  `No ${isApplication ? 'Application' : 'Decision'} XML available`
);

const viewer = (content: string, isApplication = false) => {
  return (
    <List>
      <ListHeader divider={true}>
        <ListItemText sx={{ width: '50%', textAlign: 'center' }}>{isApplication ? 'Application' : 'Decision'}</ListItemText>
      </ListHeader>
      <XmlWrapper>
        {
          content ?
            <XMLViewer xml={content} />
            : <Typography
              fontWeight="bold"
              sx={{ display: 'block', textAlign: 'center' }}
            >
              {getDefaultText(isApplication)}
            </Typography>
        }
      </XmlWrapper>
    </List>
  );
};

export const ViewXmlModal = ({ onClose, data, viewXmlModalPosition }: ViewXmlModalProps) => {
  return (
    <Modal
      open
      hideBackdrop
      dialogWidth="1359px"
      title="Financing Details XML"
      resetPosition = {viewXmlModalPosition}
      onClose={onClose}
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          md={6}
        >
          {viewer(data?.contentApplication || '', true)}
        </Grid>
        <Grid
          item
          md={6}
        >
          {viewer(data?.contentDecision || '')}
        </Grid>
      </Grid>
    </Modal>
  );
};